import ReactGA from "react-ga4";
import {
  captureInvitationEntry,
  readInvitationToken,
} from "./auth/invitation-return";
import appConfig from "./configs/app.config";

let disabledForDocument = false;

export function canTrackTelemetry() {
  return (
    !disabledForDocument &&
    window.location.pathname !== "/company-invitation" &&
    !readInvitationToken()
  );
}

export const telemetryLocation = () =>
  `${window.location.origin}${window.location.pathname}`;

export function initializeTelemetry() {
  const invitationEntry = captureInvitationEntry(new URL(window.location.href));

  // Keep third-party telemetry absent for the lifetime of an invitation
  // document, including authentication interruptions and reloads. The app
  // continues normally without analytics; no secret is copied into events.
  disabledForDocument = invitationEntry || !!readInvitationToken();
  if (disabledForDocument) return;

  ReactGA.initialize("G-EEVF4E1HNZ", {
    testMode: appConfig.projectEnvironment !== "production",
    gaOptions: {
      debug_mode: appConfig.projectEnvironment !== "production",
    },
    gtagOptions: {
      page_location: telemetryLocation(),
      page_referrer: "",
      debug_mode: appConfig.projectEnvironment !== "production",
    },
  });

  const id = import.meta.env.VITE_HOTJAR;
  if (!id || id === "0") return;
  const hotjarWindow = window as typeof window & {
    hj?: ((...args: unknown[]) => void) & { q?: unknown[][] };
    _hjSettings?: { hjid: string; hjsv: number };
  };
  hotjarWindow.hj ??= (...args: unknown[]) => {
    const queue = hotjarWindow.hj?.q ?? [];
    queue.push(args);
    if (hotjarWindow.hj) hotjarWindow.hj.q = queue;
  };
  hotjarWindow._hjSettings = { hjid: id, hjsv: 6 };
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://static.hotjar.com/c/hotjar-${id}.js?sv=6`;
  document.head.appendChild(script);
}
